// // src/supabaseClient.js

// import { createClient } from '@supabase/supabase-js'

// const supabaseUrl = "https://yaaobexfoabasueqmbdw.supabase.co";
// const supabaseAnonKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InlhYW9iZXhmb2FiYXN1ZXFtYmR3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTI2MjEwMjAsImV4cCI6MjA2ODE5NzAyMH0.QmTXK1sribesoKxHokah0WX4fR6dr4NN6RrZyCOfkr0";

// export const supabase = createClient(supabaseUrl, supabaseAnonKey);



// src/supabaseClient.js
import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || "https://xfggamqntituxvpctjji.supabase.co";
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InhmZ2dhbXFudGl0dXh2cGN0amppIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzg2NDAyNzEsImV4cCI6MjA5NDIxNjI3MX0.sv5m5kYyht8KL3Mhj15J0lgZtEC9lHPVTosFfZb3m6Q";

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  }
});

/**
 * Synchronously get the cached session from localStorage fallback
 */
export const getCachedSession = () => {
  try {
    const storageKey = Object.keys(localStorage).find(
      (key) => key.startsWith("sb-") && key.endsWith("-auth-token")
    );
    if (storageKey) {
      const localData = JSON.parse(localStorage.getItem(storageKey));
      if (localData && localData.access_token) {
        return localData;
      }
    }
  } catch (e) {
    console.error("Error reading cached session:", e);
  }
  return null;
};


/**
 * Timeout helper wrapper for promises
 */
const withTimeout = (promise, ms = 5000) => {
  return Promise.race([
    promise,
    new Promise((_, reject) => setTimeout(() => reject(new Error("Auth request timed out")), ms))
  ]);
};

/**
 * Safely get session with timeout
 */
export const getSafeSession = async (timeoutMs = 15000) => {
  try {
    return await withTimeout(supabase.auth.getSession(), timeoutMs);
  } catch (err) {
    console.warn("Supabase getSession timed out or failed:", err);
    return { data: { session: null }, error: err };
  }
};

/**
 * Safely get user with timeout
 */
export const getSafeUser = async (timeoutMs = 15000) => {
  try {
    return await withTimeout(supabase.auth.getUser(), timeoutMs);
  } catch (err) {
    console.warn("Supabase getUser timed out or failed:", err);
    return { data: { user: null }, error: err };
  }
};

/**
 * Synchronously get the cached profile from localStorage
 */
export const getCachedProfile = (userId) => {
  if (!userId) return null;
  try {
    const raw = localStorage.getItem(`seenbyai_profile_${userId}`);
    if (raw) {
      const parsed = JSON.parse(raw);
      if (parsed && typeof parsed === "object") {
        return parsed;
      }
    }
  } catch (e) {
    console.error("Error reading cached profile:", e);
  }
  return null;
};

/**
 * Save user profile to localStorage for instant hydration
 */
export const setCachedProfile = (userId, profile) => {
  if (!userId || !profile) return;
  try {
    localStorage.setItem(`seenbyai_profile_${userId}`, JSON.stringify(profile));
  } catch (e) {
    console.error("Error saving cached profile:", e);
  }
};

/**
 * Remove cached profile from localStorage
 */
export const clearCachedProfile = (userId) => {
  try {
    if (userId) {
      localStorage.removeItem(`seenbyai_profile_${userId}`);
    }
    const keysToRemove = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && key.startsWith("seenbyai_profile_")) {
        keysToRemove.push(key);
      }
    }
    keysToRemove.forEach((key) => localStorage.removeItem(key));
  } catch (e) {
    console.error("Error clearing cached profile:", e);
  }
};

/**
 * Manually delete Supabase keys and cached profiles from localStorage to prevent redirect loops
 */
export const clearSupabaseAuthStorage = () => {
  try {
    const keysToRemove = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (
        key &&
        ((key.startsWith("sb-") && key.endsWith("-auth-token")) ||
          key.startsWith("seenbyai_profile_"))
      ) {
        keysToRemove.push(key);
      }
    }
    keysToRemove.forEach(key => localStorage.removeItem(key));
  } catch (e) {
    console.error("Error clearing Supabase storage:", e);
  }
};
